import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';
import './AdminLayout.css';

const ROLE_LABEL = {
  admin: 'Administrator',
  manager: 'Manager',
};

/**
 * The persistent black global nav + parchment sub-nav that wraps every
 * console page. Keeps the Apple two-row navigation rhythm.
 */
export default function AdminLayout({ title, actions, children }) {
  const { profile, role, isAdmin, signOut } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const onSignOut = async () => {
    await signOut();
    navigate('/admin/login', { replace: true });
  };

  return (
    <div className="admin-root admin-shell">
      {/* Global nav – true black, ultra thin */}
      <nav className="global-nav">
        <Link to="/admin" className="global-nav-brand">
          <span className="global-nav-mark">MC</span>
          <span>Staff Console</span>
        </Link>
        <div className="global-nav-links">
          <Link
            to="/admin"
            className={location.pathname === '/admin' ? 'gnav-link active' : 'gnav-link'}
          >
            Calls
          </Link>
          <Link
            to="/admin/jobs"
            className={location.pathname === '/admin/jobs' ? 'gnav-link active' : 'gnav-link'}
          >
            Job Progress
          </Link>
          {isAdmin && (
            <Link
              to="/admin/reports"
              className={location.pathname === '/admin/reports' ? 'gnav-link active' : 'gnav-link'}
            >
              Reports
            </Link>
          )}
          {isAdmin && (
            <Link
              to="/admin/users"
              className={location.pathname === '/admin/users' ? 'gnav-link active' : 'gnav-link'}
            >
              People
            </Link>
          )}
        </div>
        <div className="global-nav-right">
          <span className="global-nav-user">
            {profile?.full_name || profile?.email}
            <span className="global-nav-role">{ROLE_LABEL[role] || role}</span>
          </span>
          <button className="btn btn-utility" onClick={onSignOut}>
            Sign Out
          </button>
        </div>
      </nav>

      {/* Sub-nav – frosted parchment, title left, page actions right */}
      <div className="sub-nav">
        <h3 className="sub-nav-title">{title}</h3>
        <div className="sub-nav-actions">{actions}</div>
      </div>

      <main className="admin-main">{children}</main>
    </div>
  );
}
